export class RegisterRevealFormSaveModel{
    companyName:string;
    companyManagement:string;
    distributor:string;
    telephoneNr:string;
    email:string;
    country:string;
    communicationLanguage:string;
    profession:string;
    revealSerialNr:string;
    purchaseDate:any;
    invoiceNr:string;
    constructor(
      companyName: string,
      companyManagement: string,
      distributor:string,
      telephoneNr:string,
      email:string,
      country:string,
      communicationLanguage:string,
      profession:string,
      revealSerialNr: string,
      purchaseDate:any,
      invoiceNr:string
    ) {
          this.companyName= companyName;
          this.companyManagement= companyManagement;
          this.distributor=distributor;
          this.telephoneNr= telephoneNr;
          this.email= email;
          this.country=country;
          this.communicationLanguage=communicationLanguage;
          this.profession=profession;
          this.revealSerialNr = revealSerialNr;
          this.purchaseDate=purchaseDate;
          this.invoiceNr=invoiceNr;
      }
  
  }